import { render, staticRenderFns } from "./MerchantAutoSweepComponent.vue?vue&type=template&id=5cf05b66&scoped=true&"
import script from "./MerchantAutoSweepComponent.vue?vue&type=script&lang=js&"
export * from "./MerchantAutoSweepComponent.vue?vue&type=script&lang=js&"
import style0 from "./MerchantAutoSweepComponent.vue?vue&type=style&index=0&id=5cf05b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf05b66",
  null
  
)

export default component.exports